import { render, staticRenderFns } from "./AddOpportunityLabelDialog.vue?vue&type=template&id=71b67102"
import script from "./AddOpportunityLabelDialog.vue?vue&type=script&lang=js"
export * from "./AddOpportunityLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOpportunityLabelDialog.vue?vue&type=style&index=0&id=71b67102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports